import React, { useContext, useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

import { ConfigurationContext, ContentContext } from '../../../context';

import { useNavigate } from 'react-router-dom';

import { HiMagnifyingGlass } from "react-icons/hi2";

import CampaignsTable from '../../../components/Stores/CampaignsTable';
import ButtonCustom from '../../../components/elements/ButtonCustom';
import InputCustom from '../../../components/elements/InputCustom';
import SelectCustom from '../../../components/elements/SelectCustom';
import { useTranslation } from 'react-i18next';

import { isJSON,
         validateKeywords } from '../../../helpers/functions';

const WrapperStyled = styled.div`
    width: 100%;

  >.actions{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    .bt_create_user{

    }
    .bt_export_user{
        margin-left: 10px;
    }
    .bt_go_to_benefits_admin{
        margin-left: 10px;
    }
  }
  >.filter_actions{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;//space-between;
    margin-top: 0;
    width: 100%;
    .field_keywords{
        width: 100%;
    }
    .filter_option{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        margin-top: 10px;
        .label_title{
            font-size: 15px;
            margin-right: 0;
            white-space: nowrap;
            &.order_by{
                margin-left: 1vw;
            }
        }
        .field_status{
            width: 8vw;
            margin-left: 1vw;
        }
        .field_benefits{
            width: 14vw;
            margin-left: 1vw;
        }
        .field_order_by{
            width: 11vw;
            margin-left: 1vw;
        }
        .field_area{
            width: 13vw;
            margin-left: 1vw;
        }
        .field_activities{
            width: 13vw;
            margin-left: 1vw;
        }
        .field_campaigns{
            width: 13vw;
            margin-left: 1vw;
        }
    }
    .bt_filter{
        margin-left: 1vw;
        align-self: flex-end;
    }
  }
  >.content{
    margin-top: 20px;
  }
`

const CampaignsContainer = () => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const { panColors } = useContext(ConfigurationContext);
    const { basicData } = useContext(ContentContext);
    
    //const [ filters, setFilters ] = useState({date_order: -1, text_filter: "", status: "", campaign_id: null, area: "", activity_id: ""});
    const [ filters, setFilters ] = useState({date_order: -1, text_filter: "", status: "", campaign_id: null, area: ""});
    const [ dateOrder, setDateOrder ] = useState("0");
    const [ status, setStatus ] = useState("");
    const [ campaign, setCampaign ] = useState("");
    const [ area, setArea ] = useState("");
    const [ activity, setActivity ] = useState("");
    
    const [ orderBy, setOrderBy ] = useState("date|-1");
    const [ keywords, setKeywords ] = useState({ value: "", 
                                                 required: false, 
                                                 disabled: false, 
                                                 ref: "keywords", 
                                                 label: t("texts.Palabra / Frase Clave"), 
                                                 placeholder: t("texts.Buscar") + "....",
                                                 help: "",
                                                 error: false})

    const [ filtersError, setFiltersError ] = useState(false);



    const statusList = [{_id: "", name: t("texts.Estados") + "..."},
                        {_id: "0", name: t("texts.Pendiente")}, 
                        {_id: "1", name: t("texts.Aprobado")},
                        {_id: "2", name: t("texts.En revision")},
                        {_id: "3", name: t("texts.Rechazado")}]; 

    const alphabeticalDateOrderList = [{_id: "date|-1", name: t("texts.Fecha mas reciente")}, 
                                       {_id: "date|1", name: t("texts.Fecha mas antigua")}];    
    
    const formStyle = {background_color: `rgba(${panColors.white}, 1)`,
                       border_color: `rgba(${panColors.middle_gray}, 1)`};
    
    const statusRef = useRef(status);
    const keywordsRef = useRef(keywords);
    
    

    const handleCreate = () => {
        navigate(`/benefits/create`);
    }

    const handleFormElementChange = (name, value) => {

        let valid = true;

        switch (name) {
           
            case "keywords":

                valid = validateKeywords(value);
                let updateKeywords = {...keywords};
                if(!valid){
                    setFiltersError(true);
                    updateKeywords.error = true;
                }else{
                    setFiltersError(false);
                    updateKeywords.error = false;
                }
                updateKeywords.value = value;
                setKeywords(updateKeywords);
                keywordsRef.current = value;
                
                break;
            case "campaigns":
                setCampaign(value);
                break;
            case "area":
                setArea(value);
                break;
            // case "activities":
            //     setActivity(value);
            //     break;
            // case "status":
            //     setStatus(value);
            //     statusRef.current = value;
            //     break;
            case "order_by":
                setOrderBy(value);
                const orderBy_splitted = value.split("|");
                if(orderBy_splitted[0] === "date"){
                    setDateOrder(orderBy_splitted[1]);
                }
                break;
            
                
            default:
                break;
            
        }
    }

    const handleKeyDown = (e) => {
        
        const update_filters = {...filters};
        //update_filters.status = status;
        update_filters.campaign_id = campaign;
        update_filters.area = area;
        //update_filters.activity_id = activity;
        update_filters.date_order = dateOrder;
        update_filters.text_filter = keywords.value;
        //return null;
        setFilters(update_filters);
        localStorage.setItem('store_campaign_filters', JSON.stringify(update_filters));
        
    }

    /*
    useEffect(() => {
      
        if(basicData){
            if("campaigns" in basicData){
                if(basicData.campaigns.length){
                    setCampaign(basicData?.campaigns[0]._id);
                    const update_filters = {...filters};
                    update_filters.status = status;
                    update_filters.campaign_id = basicData?.campaigns[0]._id;
                    update_filters.area = area;
                    update_filters.activity_id = activity;
                    update_filters.date_order = dateOrder;
                    update_filters.text_filter = keywords.value;
                    setFilters(update_filters);
                }
            }
        }
    
      return () => {}
    }, [basicData])
    */
    
    useEffect(() => {
        //localStorage.removeItem('store_campaign_filters');
        if(basicData){
            
            if("campaigns" in basicData){
                if(localStorage.getItem('store_campaign_filters') && isJSON(localStorage.getItem('store_campaign_filters'))){
                    const storedFilter = JSON.parse(localStorage.getItem('store_campaign_filters'));

                    setCampaign(storedFilter.campaign_id);
                    const update_filters = {...filters};
                    //update_filters.status = storedFilter.status;
                    update_filters.campaign_id = storedFilter.campaign_id;
                    update_filters.area = storedFilter.area;
                    //update_filters.activity_id = storedFilter.activity_id;
                    update_filters.date_order = storedFilter.date_order;
                    update_filters.text_filter = storedFilter.text_filter;
                    setFilters(update_filters);

                    setCampaign(storedFilter.campaign_id);
                    //setActivity(storedFilter.activity_id);
                    setArea(storedFilter.area);
                    //setStatus(storedFilter.status);

                    if(storedFilter.text_filter){
                        setKeywords((prevKeywords) => ({ ...prevKeywords, value: storedFilter.text_filter }));
                    }

                    
                }else{
                    setCampaign(basicData?.campaigns[0]._id);
                    const update_filters = {...filters};
                    //update_filters.status = status;
                    update_filters.campaign_id = basicData?.campaigns[0]._id;
                    update_filters.area = area;
                    //update_filters.activity_id = activity;
                    update_filters.date_order = dateOrder;
                    update_filters.text_filter = keywords.value;
                    setFilters(update_filters);

                    setCampaign(basicData?.campaigns[0]._id);
                }
            }
        }
      return () => {}
    }, [basicData])

    if(!filters.campaign_id){
        return null;
    }
    
    return (
        <WrapperStyled>

            <div className="filter_actions">

                <InputCustom 
                    name={keywords.ref}
                    label={""}//keywords.label
                    placeholder={keywords?.placeholder}
                    onChange={handleFormElementChange}
                    onKeyDown={null}
                    onKeyUp={null}
                    className={`field field_${keywords.ref}${keywords.error ? " error" : ""}`}
                    type="text"
                    value={keywords.value}
                    help={keywords.help}
                    isRequired={keywords.required}
                    styles={
                        {background_color: `rgba(${panColors.light_white}, 1)`,
                         border_color: `rgba(${panColors.light_white}, 1)`}
                    }
                    icon={<HiMagnifyingGlass />}
                    tooltip_content={keywords.tooltip}
                    haveError={keywords.error}
                />

                <div className="filter_option"> 

                    <div className="label_title order_by">
                        {t("texts.Filtrar por")}:
                    </div>

                    <SelectCustom 
                        name={"campaigns"}
                        label={""}//Estado
                        placeholder={null}
                        onChange={handleFormElementChange}
                        className={`field field_campaigns`}
                        type="text"
                        value={campaign}
                        help={null}
                        isRequired={null}
                        styles={ formStyle }
                        label_icon={null}
                        tooltip_content={null}
                        haveError={false}
                        data={basicData?.campaigns}
                    />

                    {/* <SelectCustom 
                        name={"activities"}
                        label={""}
                        placeholder={`${t("texts.Objetivos")}...`}
                        onChange={handleFormElementChange}
                        className={`field field_activities`}
                        type="text"
                        value={activity}
                        help={null}
                        isRequired={null}
                        styles={ formStyle }
                        label_icon={null}
                        tooltip_content={null}
                        haveError={false}
                        data={basicData.activities}
                    />  */}

                    <SelectCustom 
                        name={"area"}
                        label={""}
                        placeholder={`${t("texts.Area")}...`}
                        onChange={handleFormElementChange}
                        className={`field field_area`}
                        type="text"
                        value={area}
                        help={null}
                        isRequired={null}
                        styles={ formStyle }
                        label_icon={null}
                        tooltip_content={null}
                        haveError={false}
                        data={basicData.areas}
                    /> 
                     
                    {/* <SelectCustom 
                        name={"status"}
                        label={""}//Estado
                        placeholder={null}
                        onChange={handleFormElementChange}
                        className={`field field_status`}
                        type="text"
                        value={status}
                        help={null}
                        isRequired={null}
                        styles={ formStyle }
                        label_icon={null}
                        tooltip_content={null}
                        haveError={false}
                        data={statusList}
                    /> */}
                  
                    {/* <div className="label_title order_by">
                        Ordenar por:
                    </div>
                    <SelectCustom 
                        name={"order_by"}
                        label={""}
                        placeholder={null}
                        onChange={handleFormElementChange}
                        className={`field field_order_by`}
                        type="text"
                        value={orderBy}
                        help={null}
                        isRequired={null}
                        styles={ formStyle }
                        label_icon={null}
                        tooltip_content={null}
                        haveError={false}
                        data={alphabeticalDateOrderList}
                    />  */}

                    <ButtonCustom 
                        className="bt_filter"
                        text={t("texts.Filtrar")}
                        onClick={handleKeyDown}
                        style_type="normal"

                        icon={null}
                        background={{ normal: panColors.primary, hover: panColors.white }}
                        border={{ normal: panColors.primary, hover: panColors.primary }}
                        textcolor={{ normal: panColors.white, hover: panColors.primary }}
                    />

                </div>
                

            </div>

            <div className="content">
                <CampaignsTable filters={filters} /> 
            </div>
        
        </WrapperStyled>
    );
}

export default CampaignsContainer;